import { useEffect, useState } from "react";
import { initialQueryState } from "../../_metronic/helpers";
import { useQueryRequest } from "./request";

const ExceptionFilter = () => {
    const [tabFilter, setTabFilter] = useState('non_serviceable');
    const { updateState } = useQueryRequest()
    const updateFilterState = (filterState) => {
        updateState({
            filter: {
                exception_type: tabFilter,
            },
            ...initialQueryState,
        });
    }
    useEffect(() => {
        updateFilterState(tabFilter)
    }, [tabFilter])
    return (
        <div className="d-flex justify-content-center">

            <ul className="nav nav-tabs rounded-pill p-2 " style={{ maxWidth: 900, width: '100%', background: '#f5f8fa' }}>
                <li className="nav-item flex-fill text-center">
                    <div className="nav-link fs-6 fw-bold text-gray-600 d-flex align-items-center text-danger me-2" >
                        <i className="bi bi-funnel-fill text-danger fs-2 me-2"></i>
                        Filter By
                    </div>
                </li>
                <li className="nav-item flex-fill text-center">
                    <button
                        className={`nav-link rounded-pill fs-6   mx-1${tabFilter === 'non_serviceable' ? ' active fw-bold' : ''}`}
                        type="button"
                        onClick={() => setTabFilter('non_serviceable')}
                        style={{ minWidth: 120 }}
                    >
                        <i className="bi bi-geo-alt me-2"></i>
                        Non-Serviceable
                    </button>
                </li>
                {/* <li className="nav-item flex-fill text-center">
                <button
                    className={`nav-link rounded-pill fs-5 mx-1${tabFilter === 'bank' ? ' active fw-bold' : ''}`}
                    type="button"
                    onClick={() => setTabFilter('bank')}
                    style={{ minWidth: 120 }}
                >
                    <i className="bi bi-bank2 me-2"></i>
                    Bank
                </button>
            </li> */}
                <li className="nav-item flex-fill text-center">
                    <button
                        className={`nav-link rounded-pill fs-6 mx-1${tabFilter === 'abort_refund' ? ' active fw-bold' : ''}`}
                        type="button"
                        onClick={() => setTabFilter('abort_refund')}
                        style={{ minWidth: 150 }}
                    >
                        <i className="bi bi-x-circle me-2"></i>
                        Abort Refund
                    </button>
                </li>
                <li className="nav-item flex-fill text-center">
                    <button
                        className={`nav-link rounded-pill fs-6 mx-1${tabFilter === 'abort_reprocess' ? ' active fw-bold' : ''}`}
                        type="button"
                        onClick={() => setTabFilter('abort_reprocess')}
                        style={{ minWidth: 170 }}
                    >
                        <i className="bi bi-arrow-repeat me-2"></i>
                        Abort ReProcess
                    </button>
                </li>
                <li className="nav-item flex-fill text-center">
                    <button
                        className={`nav-link rounded-pill fs-6 mx-1${tabFilter === 'dbt_failed' ? ' active fw-bold' : ''}`}
                        type="button"
                        onClick={() => setTabFilter('dbt_failed')}
                        style={{ minWidth: 170 }}
                    >
                        <i className="bi bi-arrow-repeat me-2"></i>
                        DBT Failed
                    </button>
                </li>
            </ul>
        </div>
    )
}

export { ExceptionFilter }